import request from '@/utils/request'

export function getTcntbaspInfo() {
  return request({
    url: '/api/tcntbasp/getInfo',
    method: 'get',
  })
}
export function getAcceptOrderBaseList() {
  return request({
    url: '/api/tcntbasp/getAcceptOrderBaseList',
    method: 'post',
  })
}
export function getAcceptOrderBaseUpdateList() {
  return request({
    url: '/api/tcntbasp/getAcceptOrderBaseUpdateList',
    method: 'post',
  })
}
